import { secureGetAPI, securePostAPIWithoutHeadersWithoutOverlay, securePostAPI, securePutAPIWithoutOverlay, securePostAPIWithoutOverlay, fetchAPIUrls, secureGetAPIWithCredentials, secureDeleteAPI, secureGetAPIWithoutOverlay } from "@/services/apiService";
import { getLoggedInUserOrganization, getLoggedInUserId } from "@/services/authService";
import { getLocalForageItem, setLocalForageItem } from "@/services/localforageService";
import store from ".";
import { uploadJsonFile } from "@/services/storageService";
import { fetchFormsForUser } from "@/services/formService";
import { selfTestPostAPI, selfTestGetAPI } from "@/services/apiService";
import { fetchPTMNotifications, markPTMNotificationSeen } from "@/services/meetService";

// Identifies this app to the shared OTP login Lambda, which records where each login came from
const OTP_LOGIN_SOURCE = "mento-test-ui";

export default {
  async fetchUnreadNotificationsCount({ commit, state }) {
    const userMessages = state.userMessages || [];
    const count = userMessages.filter(m => m.status === "unread").length;
    commit("setUnreadNotificationsCount", count);
  },

  async recordError(context, reqData) {
    const userId = context.state.userState.userId;
    const deviceId = context.state.userState.deviceId;
    return securePostAPIWithoutHeadersWithoutOverlay(
      { ...reqData, UserId: userId, DeviceId: deviceId, RequestId: "" },
      `mysa/error`
    ).then((response) => {
      if (!response) {
        response = {};
      }
      return;
    });
  },

  async getAPIUrlsForFlavorAndVersion(context) {
    return fetchAPIUrls().then((response) => {

      context.commit("setAPIUrlsForFlavorAndVersion", response);
    });
  },

  async userSSO(context, reqData) {
    return securePostAPI({ ...reqData }, "mysa/idam/validatessotoken").then(response => {
      if (!response) {
        response = {};
      }
      if ('error' in response) {
        context.commit("setLoginError", response);
      }
      else {
        context.commit("userLoggedIn", response);
      }
    });
  },

  async userLoginByPhoneNumber(context, reqData) {
    //const orgIdToAutheticate = context.state.app_defaultOrgnizationIdForFlavor;
    context.commit("clearLoginError");
    return securePostAPIWithoutOverlay(
      { ...reqData },
      `auth/mysa/users`
    ).then((response) => {
      if (!response) {
        response = {};
      }
      if ("error" in response) {
        context.commit("setLoginError", response);
      } else {
        context.commit("setTempUserLoggedInPhoneNumber", response);
      }
    });
  },

  async requestPhoneNumbers(context, reqData) {
    context.commit("clearLoginError");
    return securePostAPIWithoutOverlay(
      { ...reqData, source: OTP_LOGIN_SOURCE },
      `auth/mysa/otp/phoneNumbers`
    ).then((response) => {
      if (!response) {
        response = {};
      }
      if ("error" in response) {
        console.log('error response requestPhoneNumbers', response.data.message)
        context.commit("setLoginError", response.data.message);
      } else {
        return response
      }
      return
    })
  },

  async sendOtp(context, reqData) {
    context.commit("clearLoginError");
    return securePostAPIWithoutOverlay(
      { ...reqData, source: OTP_LOGIN_SOURCE },
      `auth/mysa/otp/sendOtp`
    ).then((response) => {
      if (!response) {
        response = {};
      }
      if ("error" in response) {
        console.log('error response sendOTP', response.data.message)
        context.commit("setLoginError", response.data.message);
      } else {
        return response
      }
      return
    })
  },

  async sendEmailOtp(context, reqData) {
    context.commit("clearLoginError");
    return securePostAPIWithoutOverlay(
      { ...reqData, source: OTP_LOGIN_SOURCE },
      `auth/mysa/otp/sendEmailOtp`
    ).then((response) => {
      if (!response) {
        response = {};
      }
      if ("error" in response) {
        context.commit("setLoginError", response.data.message);
      } else {
        return response
      }
      return
    })
  },

  async verifyOtp(context, reqData) {
    context.commit("clearLoginError");
    return securePostAPIWithoutOverlay(
      { ...reqData, source: OTP_LOGIN_SOURCE },
      `auth/mysa/otp/verifyOtp`
    ).then((response) => {
      if (!response) {
        response = {};
      }
      if ("error" in response) {
        console.log('error response verifyOtp', response.data.message)
        context.commit("setLoginError", response.data.message);
      } else {
        context.commit("userLoggedIn", response);
      }
      return
    })
  },

  async validateOTP(context, reqData) {
    //const orgIdToAutheticate = context.state.app_defaultOrgnizationIdForFlavor;
    const userId = context.state.tempLogInPhoneNumberData.userId;
    context.commit("clearLoginError");
    return securePostAPIWithoutOverlay(
      { ...reqData },
      `auth/mysa/users/${userId}/verification/validate`,
    ).then((response) => {
      if (!response) {
        response = {};
      }

      if ("error" in response) {
        context.commit("setLoginError", response);
      } else if (!response.isVerified) {
        context.commit("setLoginError", { error: "Invalid OTP" });
      } else {
        context.commit("updateTempPhonenumberLoginData", response);
      }
    });
  },

  async setUsernameAndInfo(context, reqData) {
    //const orgIdToAutheticate = context.state.app_defaultOrgnizationIdForFlavor;
    const userId = context.state.tempLogInPhoneNumberData.userId;
    context.commit("clearLoginError");
    return securePutAPIWithoutOverlay(
      { ...reqData },
      `auth/mysa/users/${userId}`,
      {
        'Content-Type': 'application/json; charset=UTF-8',
        'Authorization': 'Bearer ' + context.state.tempLogInPhoneNumberData.accessToken
      }
    ).then((response) => {
      if (!response) {
        response = {};
      }
      if ("error" in response) {
        context.commit("setLoginError", response);
      } else {
        context.commit("updateTempPhonenumberLoginData", response);
      }
    });
  },

  async logInPhonenumberUser(context) {
    context.commit("userLoggedIn", context.state.tempLogInPhoneNumberData);
    context.commit("emptyTempState");
  },

  async userLoginByCredentials(context, reqData) {
    const orgIdToAutheticate = context.state.app_defaultOrgnizationIdForFlavor;
    context.commit("clearLoginError");
    return securePostAPIWithoutOverlay(
      { ...reqData },
      `mysa/connectorg/organizations/${orgIdToAutheticate}/login`
    ).then((response) => {
      if (!response) {
        response = {
          loginFlow: 'activation-code'
        };
      }
      if ("error" in response) {
        context.commit("setLoginError", response);
      } else {
        // This is for tempLogIn
        context.commit("userTempLoggedIn", { ...response, loginFlow: 'activation-code'});
        //Below is for permanent LogIn 
        //Plesae do not Un-comment it.
        //context.commit("userLoggedIn", response);
      }
    });
  },
  async setRefundPolicyStatus(context, reqData) {
    let userId = context.state.tempLoggedIn.userId;
    return securePostAPI(
      { ...reqData },
      `mysa/connectorg/users/${userId}/updateRefundPolicyStatus`
    ).then((response) => {
      if (response.success && reqData.isRefundPolicyAccepted) {
        const data = context.state.tempLoggedIn;
        context.commit("userLoggedIn", data);
      } else if (reqData.isRefundPolicyAccepted) {
        context.commit("setLoginError", { error: "Error setting refund policy. Please try again after some time" });
      }
      return response;
    });
  },
  async LogInUser(context) {
    const response = context.state.tempLoggedIn;
    context.commit("userLoggedIn", response);
  },


  async userLoginByCredentialsToSpecificOrg(context, reqData) {
    console.log('insideloginaction')
    const orgIdToAutheticate = reqData.orgId;
    context.commit("clearLoginError");
    return securePostAPIWithoutOverlay({ ...reqData }, `mysa/connectorg/organizations/${orgIdToAutheticate}/login`).then(response => {
      if (!response) {
        response = {
          loginFlow: 'activation-code'
        };
      }
      if ('error' in response) {
        context.commit("setLoginError", response);
      }
      else {
        context.commit("userLoggedIn", { ...response, loginFlow: 'activation-code' });
      }
    });
  },

  async logout(context) {
    context.commit("logout");
    context.commit("resetStateToDefault");
  },

  async loadDomainsList(context) {
    let userOrgId = getLoggedInUserOrganization();

    if (!userOrgId || userOrgId == '' || userOrgId.toLowerCase() == 'undefined') {
      userOrgId = context.state.app_defaultOrganizationIdForFlavor;
    }
    let reqData = { organizationId: userOrgId }
    return secureGetAPI({ ...reqData }, `mysa/dashboard/domains?organizationId=${userOrgId}`).then(response => {
      if (!response) {
        response = {};
      }
      context.commit("loadDomainsList", response);
    });
  },

  async fetchProfileInfo(context) {
    let userId = getLoggedInUserId();
    let apiPath = `mysa/connectorg/users/${userId}/fetchUser`;
    return secureGetAPI({}, apiPath).then((response) => {
      if (!response) {
        response = {};
      }
      context.commit("fetchProfileInfo", response);
      if (!response) {
        context.commit("profileInfoLoadedFromServer", false);
      } else {
        context.commit("profileInfoLoadedFromServer", true);
      }
    });
  },
  async updateEmailForDiscourse(context, data) {
    let apiPath = `discoursetoken/updateEmail`;
    return securePostAPI(data, apiPath).then((response) => {
      if (!response) {
        response = {};
      }
      context.commit("updateEmailForDiscourse", data.email);

    });
  },

  async checkFeatures(context) {
    let apiPath = `mysa/checkfeatures`;
    return securePostAPI({}, apiPath).then((response) => {
      if (!response) {
        response = {};
      }
      context.commit("checkFeatures", response);
    });
  },
  async deleteProfile(context) {
    let userId = getLoggedInUserId();
    let apiPath = `mysa/connectorg/users/${userId}/deleteUser`;
    return secureDeleteAPI({}, apiPath).then((response) => {
      if (!response) {
        response = {};
      }
      if (response.error !== '') {
        console.log("error in the program", response.error);
        context.commit("setProfileDeleteError", response)
        console.log(context.state.deleteProfileError);
      }
      else {
        console.log("no error in the program")
      }
    });
  },

  async loadLearnHierarchyRootNodes(context) {
    let userOrgId = getLoggedInUserOrganization();
    let userId = getLoggedInUserId();
    let domainId = context.state.userCurrentDomain;
    let apiPath = `mysa/practice/organization/${userOrgId}/users/${userId}/domains/${domainId}/node/`;
    return secureGetAPI({}, apiPath).then(response => {
      if (!response) {
        response = {};
      }
      context.commit("loadLearnHierarchyChildNodes",
        { parentNodeId: domainId, children: response });

    });
  },

  async clearLearnHierarchyNodes(context) {
    context.commit("clearLearnHierarchyNodes");
  },

  async markLearnNodeAsRead(context, reqData) {
    //console.log(reqData);
    let parerntNodeId = reqData.parentId;
    let nodeContentId = reqData.children.nodeContentId;
    let preApiPath = `mysa/practice`;
    let apiPath = `/node/${parerntNodeId}/content/${nodeContentId}/markRead`;
    //console.log(apiPath);
    return securePostAPI({}, preApiPath + apiPath).then(response => {
      if (!response || response === undefined) {
        response = {};
      }
      if (response.success) {
        context.commit('unlockNextNodeContent', reqData);
      }
      return response;
    });
  },
  async loadLearnHierarchyNodesUnderaNode(context, reqData) {
    //console.log(`loadLearnHierarchyNodesUnderaNode: ${JSON.stringify(reqData)}`);
    let userOrgId = getLoggedInUserOrganization();
    let userId = getLoggedInUserId();
    let domainId = context.state.userCurrentDomain;

    let apiPath = `mysa/practice/organization/${userOrgId}/users/${userId}/domains/${domainId}/`;
    let parentNodeId = null;
    if (reqData.nodeType == "FOLDER" || reqData.nodeType == "SUBFOLDER") {
      //if Children of a Folder or SubFolder are being requested
      apiPath = apiPath + `folder/${reqData.nodeId}`;
      parentNodeId = reqData.nodeId;
    } else if (
      reqData.nodeType == "COLLECTION" &&
      reqData.collectionType == "VIDEO"
    ) {
      //if Children of Video Collection
      apiPath = apiPath + `videocollections/${reqData.collectionId}`;
      parentNodeId = reqData.collectionId;
    } else if (
      reqData.contentType == "COLLECTION" &&
      reqData.collectionType == "VIDEO"
    ) {
      //if Children of Video Collection under a folder/subfolder
      apiPath = apiPath + `videocollections/${reqData.contentId}`;
      parentNodeId = reqData.contentId;
    } else if (
      reqData.nodeType == "COLLECTION" &&
      reqData.collectionType == "PDF"
    ) {
      //if Children of PDF Collection
      apiPath = apiPath + `pdfcollections/${reqData.collectionId}`;
      parentNodeId = reqData.collectionId;
    } else if (
      reqData.contentType == "COLLECTION" &&
      reqData.collectionType == "PDF"
    ) {
      //if Children of PDF Collection under a folder/subfolder
      apiPath = apiPath + `pdfcollections/${reqData.contentId}`;
      parentNodeId = reqData.contentId;
    } else {
      //if Children of other Node Types Collection
      apiPath = apiPath + `node/${reqData.nodeId}`;
      parentNodeId = reqData.nodeId;
    }
    return secureGetAPI({}, apiPath).then((response) => {
      if (!response) {
        response = {};
      }
      context.commit("loadLearnHierarchyChildNodes", {
        parentNodeId: parentNodeId,
        children: response,
      });
    });
  },

  async getCloudFrontCookies(context, reqData) {
    return secureGetAPIWithCredentials(
      { ...reqData },
      "cloudfrontcookies"
    ).then((response) => {
      if (!response) {
        response = {};
      }
      context.commit("updateCloudFrontCookieResponse", response);
    });
  },

  async loadUserTestCollections(context, reqData) {
    if (!context.state.userTestCollectionsLoadedFromServer) {
      return secureGetAPI(
        { ...reqData },
        "mysa/studenttest/testcollection"
      ).then((response) => {
        if (!response) {
          response = {};
        }
        context.commit("loadUserTestCollections", response);
        context.commit("userTestCollectionsLoadedFromServer", true);
      });
    }
  },
  //Homework APIS
  async loadHomeworks(context, reqData) {
    let userId = getLoggedInUserId();
    if (!context.state.homeworksLoadedFromServer) {
      return secureGetAPI(
        { ...reqData },
        `mysa/practice/users/${userId}/getUserHomeworkTasks`
      ).then((response) => {
        //console.log("homework Response", JSON.stringify(response,null,4));
        if (!response) {
          response = {};
        }
        context.commit("loadHomeworks", response);
        context.commit("homeworksLoadedFromServer", true);
      });
    }
  },
  uploadS3SubjectiveHomework(context, reqData) {
    console.log(reqData)
    return securePostAPI(
      { ...reqData },
      `mysa/practice/homework/uploadS3HomeworkDocument`
    ).then((response) => {
      // console.log("s3 document", JSON.stringify(response,null,4));
      // console.log(response)
      if (!response) {
        response = {};
      }
      if (response.error) {
        return;
      }
      if (response.success !== undefined && !response.success) {
        return { error: response.message };
      }
      context.commit("homeworkS3DocumentData", response);
      return response;
    });
  },
  startHomeworkTask(context, reqData) {
    let userId = getLoggedInUserId();
    let homeworkTaskId = reqData.homeworkTaskId;
    //console.log(reqData)
    return securePostAPI(
      { ...reqData },
      `mysa/practice/users/${userId}/homeworkTask/${homeworkTaskId}/startUserHomeworkTask`
    ).then((response) => {
      // console.log("s3 document", JSON.stringify(response,null,4));
      // console.log(response)
      if (!response) {
        response = {};
      }
      if (response.error) {
        return;
      }
      if (response.success !== undefined && !response.success) {
        return { error: response.message };
      }
      return response;
    });
  },
  submitHomeworkTask(context, reqData) {
    let userId = getLoggedInUserId();
    let homeworkTaskId = reqData.homeworkTaskId;
    //console.log(reqData)
    return securePostAPI(
      { ...reqData },
      `mysa/practice/users/${userId}/homeworkTask/${homeworkTaskId}/submitUserHomeworkTask`
    ).then((response) => {
      // console.log("s3 document", JSON.stringify(response,null,4));
      // console.log(response)
      if (!response) {
        response = {};
      }
      if (response.error) {
        return;
      }
      if (response.success !== undefined && !response.success) {
        return { error: response.message };
      }
      return response;
    });
  },

  async loadCombinedTestReports(context, reqData) {
    return secureGetAPI(reqData,
      `mysa/studenttest/getCombinedReports`
    ).then((response) => {
      if (!response) {
        response = [];
      }
      context.commit("loadCombinedTestReports", response);
      return response;
    });
  },
  async getStudentCombinedTestReport(context, reqData) {
    return secureGetAPI(
      { ...reqData },
      `mysa/studenttest/getCombinedReport/${reqData}/report`
    ).then((response) => {
      //console.log("response in actions from the api call", response);
      if (!response) {
        response = {};
      }
      context.commit("loadStudentCombinedTestReportData", response);
      return response;
    });
  },
  //test APIS
  async loadTests(context, reqData) {
    if (!context.state.testsLoadedFromServer) {
      return secureGetAPI(
        { ...reqData },
        `mysa/studenttest/collections/${reqData.collectionId}/tests`
      ).then((response) => {
        if (!response) {
          response = {};
        }
        context.commit("loadTests", response);
        context.commit("testsLoadedFromServer", true);
      });
    }
  },
  async loadTestReports(context, reqData) {
    if (!context.state.testReportsLoadedFromServer) {

      return secureGetAPI({ ...reqData }, `mysa/studenttest/test/${reqData.testId}/report`).then(response => {
        if (!response) {
          response = {};
        }
        context.commit("loadTestReports", response);
        context.commit("testReportsLoadedFromServer", true);

      });
    }
  },
  async loadSelfTestReports(context, { userId, testId }) {
    context.commit("clearSelfTestReports");
    const response = await selfTestGetAPI(
      `selfTestProcessor/test-report?userId=${encodeURIComponent(userId)}&testId=${encodeURIComponent(testId)}`,
      false
    );
    const data = response?.error ? {} : (response || {});
    context.commit("loadSelfTestReports", data);
    context.commit("selfTestReportsLoadedFromServer", true);
    return data;
  },
  async loadTestAnalytics(context, testInstanceId) {
  if (!testInstanceId) return Promise.resolve(null);
  return secureGetAPIWithoutOverlay(
    {},
    `mysa/test-analytics/get-subject-topic-stats?testInstanceId=${testInstanceId}`
  ).then(response => {
    if (response && "error" in response) {
      return null;
    }
    return response || null;
  });
  },
  async loadSubjectTopicCombinedDifficultyWise(context, testInstanceId) {
  if (!testInstanceId) return Promise.resolve(null);
  return secureGetAPIWithoutOverlay(
    {},
    `mysa/test-analytics/get-subject-topic-combined-difficulty-wise?testInstanceId=${testInstanceId}`
  ).then(response => {
    if (response && "error" in response) {
      return null;
    }
    return response || null;
  });
  },
async loadBookmarksByTest(context, testId) {
  if (!testId) return Promise.resolve(null);

  return secureGetAPIWithoutOverlay(
    {},
    `mysa/test-analytics/get-bookmarks-by-test?testId=${testId}`
  ).then(response => {
    if (!response || response.error) {
      return null;
    }

    return response || null;
  });
},

  async getTestReportForCombinedReport(context, reqData) {
    //console.log(reqData.testId , context.state.testReportsForCombinedReport, (reqData.testId in context.state.testReportsForCombinedReport));
    if (!(reqData.testId in context.state.testReportsForCombinedReport)) {
      return secureGetAPIWithoutOverlay({ ...reqData }, `mysa/studenttest/test/${reqData.testId}/report`).then(response => {
        if (!response) {
          response = {};
          return response;
        }
        context.commit("saveSingleReportData", { testId: reqData.testId, ...response });
        return response;
      });
    } else {
      return context.state.testReportsForCombinedReport[reqData.testId];
    }
  },
  async startTest(context, reqData) {
    if (!context.state.startTestLoadedFromServer) {
      return securePostAPIWithoutOverlay(
        { ...reqData },
        `mysa/studenttest/test/${reqData.testId}/startTest`
      ).then((response) => {
        if (!response) {
          response = {};
        }
        context.commit("startTest", response);
        context.commit("startTestLoadedFromServer", true);
      });
    }
  },
  async getLeaderboard(context, reqData) {
    let qp = `?testId=${reqData.testId}`;
    return secureGetAPI(
      { ...reqData },
      `mysa/test-analytics/get-leaderboard${qp}`
    ).then((response) => {
      if (!response) {
        response = [];
      }
      return response;
    });
  },
  async loadToppersReport(context, { testId, userTestMode } = {}) {
    if (!testId) return Promise.resolve(null);
    const modeParam = userTestMode ? `&userTestMode=${userTestMode}` : '';
    return secureGetAPIWithoutOverlay(
      {},
      `mysa/test-analytics/get-toppers-report?testId=${testId}${modeParam}`
    ).then(response => {
      if (response && "error" in response) {
        return null;
      }
      return response || null;
    });
  },
  async updateQuestionDurationAndResponse(context, reqData) {
    // Self-test path: fire save-answer in background, skip existing backend
    if (context.state.isSelfTest) {
      const qResponse = reqData.qResponse;
      const { testId, userTestInstanceId, userId } = context.state.selfTestData;
      // Look up extra fields from the stored question
      const allQuestions = (context.state.currentTestJson || []).flatMap(s => s.questions || []);
      const question = allQuestions.find(q => q.qId === qResponse.qId) || {};
      const savePayload = {
        userTestInstanceId,
        testId,
        userId,
        qId: qResponse.qId,
        qType: qResponse.qType,
        markedForReview: qResponse.markedForReview || false,
        subjectId: question.subjectId,
        topicId: question.topicId,
        categoryId: question.categoryId,
        difficultyLevel: question.difficultyLevel,
      };
      const qType = String(qResponse.qType);
      if (qType === '1' || qType === '2') {
        if (qResponse.checkedOption) savePayload.checkedOption = qResponse.checkedOption;
      } else if (qType === '3') {
        if (qResponse.integerOption !== '' && qResponse.integerOption != null) {
          savePayload.integerOption = Number(qResponse.integerOption);
        }
      } else if (qType === '4') {
        if (qResponse.decimalOption !== '' && qResponse.decimalOption != null) {
          savePayload.integerOption = Number(qResponse.decimalOption);
        }
      }
      selfTestPostAPI('selfTestProcessor/save-answer', savePayload, false).catch(err => {
        console.error('Self-test save-answer failed', err);
      });
      return;
    }

    //add to unsent qDuration list
    const qDuration = reqData.qDuration;
    const qResponse = reqData.qResponse;

    // console.log(qDuration);
    // console.log(qResponse);
    const qDuationLocalForageresponse = await getLocalForageItem('qDurations')
    const newQDuationArray = qDuationLocalForageresponse
    newQDuationArray.push(qDuration)
    await setLocalForageItem('qDurations', newQDuationArray)


    //// QRESPONSE (**Upsert** with search and update  ) to unSentlist

    const qResponseLocalForageresponse = await getLocalForageItem("qResponses");
    const newQResponseArray = qResponseLocalForageresponse;

    var foundQResponse =
      newQResponseArray.find((x) => x.qId == qResponse.qId) ?? null;
    console.log("found qresponse", foundQResponse);
    if (foundQResponse == null) {
      newQResponseArray.push(qResponse);
    } else {
      Object.assign(foundQResponse, qResponse);
    }

    await setLocalForageItem("qResponses", newQResponseArray);

    //api call
    let testInstanceId = store.getters.startTestInfo.testInstanceId;
    let testId = store.getters.currentTestId;

    let body = { qDuration: newQDuationArray, qResponses: newQResponseArray }
    let apiResponse = await securePostAPIWithoutOverlay(body, `mysa/studenttest/test/${testId}/testInstance/${testInstanceId}/userattempt`)
    // console.log(apiResponse);

    // console.log(body)
    // console.log("get qDuration", newQDuationArray);
    // console.log("get qResponse", newQResponseArray);

    //api call faliure
    if (
      "error" in apiResponse &&
      apiResponse.error != null &&
      apiResponse.error.length > 0
    ) {
      context.commit("updateQuestionAttemptError", apiResponse.error);
    }

    //api call success
    else {
      setLocalForageItem("qDurations", []);
      setLocalForageItem("qResponses", []);
      setLocalForageItem(
        "serverLastAttemptSavedTimeStamp",
        apiResponse.serverLastAttemptSavedTimeStamp
      );
    }
  },

  async updateSyncTimer(context, reqData) {

    let testInstanceId = store.getters.startTestInfo.testInstanceId
    let testId = store.getters.currentTestId
    let body = reqData
    let apiResponse = await securePostAPIWithoutOverlay(body, `mysa/studenttest/test/${testId}/testInstance/${testInstanceId}/syncTestTimer`)
    // console.log(apiResponse);
    context.commit("updateSyncTimer", apiResponse)

  },

  async submitTest(context) {
    // Self-test path
    if (context.state.isSelfTest) {
      const { testId, userTestInstanceId, userId, organizationId } = context.state.selfTestData;
      const result = await selfTestPostAPI('selfTestProcessor/submit-test', {
        userTestInstanceId,
        testId,
        userId,
        organizationId,
      });
      if (result && !result.error) {
        context.commit('setSelfTestSubmitResult', result);
        // No submitError → DefaultTheme will try to navigate to /testsubmission,
        // but the router guard will redirect to /selftestresult
        context.commit('updateSubmitError', '');
      } else {
        context.commit('updateSubmitError', result?.error || 'Submit failed');
      }
      return;
    }

    const qDuationLocalForageresponse = await getLocalForageItem("qDurations");
    const newQDuationArray = qDuationLocalForageresponse;

    const qResponseLocalForageresponse = await getLocalForageItem("qResponses");
    const newQResponseArray = qResponseLocalForageresponse;

    //api call
    let testInstanceId = store.getters.startTestInfo.testInstanceId;
    let testId = store.getters.currentTestId;

    let body = { qDuration: newQDuationArray, qResponses: newQResponseArray, submit: true }
    console.log(body)
    console.log("get qDuration", newQDuationArray);
    console.log("get qResponse", newQResponseArray);

    let apiResponse = await securePostAPIWithoutOverlay(body, `mysa/studenttest/test/${testId}/testInstance/${testInstanceId}/userattempt`)
    // console.log(apiResponse);

    //api call faliure
    if (
      "error" in apiResponse &&
      apiResponse.error != null &&
      apiResponse.error.length > 0
    ) {
      // do nothing
      context.commit("updateSubmitError", apiResponse.error);
    }

    //api call success
    else {
      context.commit("updateSubmissionInfo", apiResponse);
      setLocalForageItem("qDurations", []);
      setLocalForageItem("qResponses", []);
      setLocalForageItem(
        "serverLastAttemptSavedTimeStamp",
        apiResponse.serverLastAttemptSavedTimeStamp
      );
    }
  },
  async loadTestResult(context, reqData) {
    if (!context.state.currentTestResultLoadedFromServer) {
      return secureGetAPI(
        { ...reqData },
        `mysa/studenttest/test/${reqData.testId}/testInstance/${reqData.instance}/solution`
      ).then((response) => {
        if (!response) {
          response = {};
        }
        context.commit("loadTestResult", response);
        context.commit("testResultLoadedFromServer", true);
      });
    }
  },
  async lastActivity(context, reqData) {
    return securePostAPIWithoutOverlay({ ...reqData },
      `mysa/iamhere/here`
    ).then((res) => {
      //console.log("Response from i am here", res)
      if (res.logout === true && JSON.parse(localStorage.getItem("isUserLoggedIn"))) {
        //console.log("Logout user with message");
        context.commit("logoutUserSession", true);
      }
    }).catch(err => {
      console.log("error", err);
    });
  },
  async loadCalendarList(context, reqData) {
    //console.log("calling action.js")
    if (!context.state.calendarEventsLoadedFromServer) {
      return securePostAPI({ ...reqData },
        `mysa/mycalender/getEvents`
      ).then(response => {
        if (!response) {
          response = [];
        }
        //console.log("response", response);
        context.commit("loadCalendarList", response);
        context.commit("calendarEventsLoadedFromServer", true);
      });
    }
  },
  async emptyCalenderEvents(context) {
    //console.log("removing existing events");
    context.commit("emptyCalenderEvents");
  },
  async loadClassesList(context, reqData) {
    if (!context.state.classesListLoadedFromServer) {
      return securePostAPI(
        { ...reqData },
        `mysa/zoommeetings/getMeetingsForUser`
      ).then((response) => {
        if (!response) {
          response = [];
        }
        context.commit("loadClassesList", response);
        context.commit("classesListLoadedFromServer", true);
      });
    }
  },
  async loadUserMessages(context, reqData) {
    return secureGetAPI({ ...reqData }, "mysa/message/usermessages", false).then(
      async (response) => {
        if (!response) {
          response = [];
        }
        // Fetch PTM notifications and merge
        const org = context.state.profileInfo?.organization;
        const lmsUserId = org?.rollNumber || context.state.userState?.userId || localStorage.getItem('userId');
        let ptmNotifications = [];
        if (lmsUserId && lmsUserId !== 'null' && lmsUserId !== 'undefined') {
          const ptmData = await fetchPTMNotifications(lmsUserId);
          if (Array.isArray(ptmData)) {
            ptmNotifications = ptmData.map(n => ({
              userMessageId: `ptm-${n.id}`,
              title: n.title,
              description: n.message,
              messageDateTime: n.createdAt,
              status: n.studentSeen ? 'read' : 'unread',
              userStarred: false,
              importance: '',
              _isPTM: true,
              _ptmId: n.id,
              _ptmJoinUrl: n.joinUrl || null,
              _ptmStartAt: n.slot?.startAt || n.startAt || null,
              _ptmEndAt: n.slot?.endAt || n.endAt || null,
            }));
          }
        }
        context.commit("loadUserMessages", [...ptmNotifications, ...response]);
        context.commit("userMessagesLoadedFromServer", true);
      }
    );
  },
  async updateUserMessageStatus(context, reqData) {
    // Handle PTM notifications separately
    if (reqData._isPTM && reqData._ptmId && reqData.status === 'read') {
      const org = context.state.profileInfo?.organization;
      const lmsUserId = org?.rollNumber || context.state.userState?.userId || localStorage.getItem('userId');
      await markPTMNotificationSeen(reqData._ptmId, lmsUserId);
      context.commit("userMessageUpdated", true);
      return;
    }
    return securePostAPI({ ...reqData }, "mysa/message/status", false).then(
      (response) => {
        if (response && response.success) {
          context.commit("userMessageUpdated", true);
        } else {
          context.commit("userMessageUpdated", false);
        }
      }
    );
  },
  async getUserInvite(context, reqData) {
    if (!context.state.classesListLoadedFromServer) {
      return securePostAPI(
        { ...reqData },
        `mysa/zoommeetings/getMeetingInvites`
      );
    }
  },
  async getPdfUrl(context, reqData) {
    return secureGetAPI({ ...reqData }, "signedurl?path=" + reqData);
  },
  async storeUserCurrentDomain(context, reqData) {
    context.commit("storeUserCurrentDomain", reqData.domainId);
    return securePostAPI(
      { ...reqData },
      "mysa/connectorg/saveUserDomain/" + reqData.domainId,
      false
    );
  },

  async sendLogsToServer(context, data) {
    const rollnumber = localStorage.getItem('userId') || localStorage.getItem('name');
    if (data.logsName === "ui-errorLogs") {
      const blob = new Blob([JSON.stringify(context.state.errorLogs, null, 2)], { type: 'application/json' });
      await uploadJsonFile(blob, "VMCStudentDocuments/errorReportLogs", context.state.userState.userId, data.logsName, rollnumber);
    }
    if (data.logsName === "network-errorLogs") {
      const blob = new Blob([JSON.stringify(context.state.networkErrorLogs, null, 2)], { type: 'application/json' });
      await uploadJsonFile(blob, "VMCStudentDocuments/errorReportLogs", context.state.userState.userId, data.logsName, rollnumber);
    }
    if (data.logsName === "test-errorLogs") {
      const blob = new Blob([JSON.stringify(context.state.testErrorLogs, null, 2)], { type: 'application/json' });
      await uploadJsonFile(blob, "VMCStudentDocuments/errorReportLogs", context.state.userState.userId, data.logsName, rollnumber);
    }
    return;
  },

  logError({ commit }, log) {
    commit('ADD_ERROR_LOG', log);
  },
  logNetworkError({ commit }, log) {
    commit('ADD_NETWORK_ERROR_LOG', log);
  },
  logTestError({ commit }, log) {
    commit('ADD_TEST_ERROR_LOG', log);
  },
  async loadFormsForCurrentUser({ commit, state }) {

    const userId = state.profileInfo?.userId;
    if (userId) {
      const response = await fetchFormsForUser(userId);
      commit('setForms', response.forms || []);
    }
  }
};
